<template>
  <div class="block-information clearfix"  v-loading="loading">
    <div class="fr">
      <img src="@/../public/static/img/blockView/java.png">
    </div>
    <div class="fl">
      <span class="angle"></span>
      <section class="section1">
        <div class="clearfix" id="Block">
          <!--<div class="phone">
            <div class="block_cont">
              <router-link v-if="down!=0" :to="`/HyperblockView/${down}`" class="prev-block fl">
                <img src="@/../public/static/img/blockView/prev-block.png">
              </router-link>
              <a v-else href="javascript:;" class="prev-block fl disable">
                <img src="@/../public/static/img/blockView/prev-block.png">
              </a>
             <img src="@/../public/static/img/blockView/hyperchainBlockIcon.png" class="fl" style="margin-top:0px;"> 
              <div class="fl tit">超块信息</div>
              <span class="cont fl" v-text="hyper_block"></span> 
              <router-link :to="`/HyperblockView/${up}`" v-if="up!=0" class="next-block fl">
                <img src="@/../public/static/img/blockView/next-block.png">
              </router-link>
              <a v-else href="javascript:;" class="disable next-block">
                <img src="@/../public/static/img/blockView/next-block.png">
              </a>
            </div>
          </div> -->
          <div class="fl tit" v-text="$t('HyperBlockMsg')">超块信息</div>
          <div class="fr">
            <router-link v-if="down!=0" :to="`/HyperblockView/${down}`" class="a" id="prev" v-text="`<${$t('Next')}`">&lt;后一个</router-link>
            <a v-else href="javascript:;" class="a disable" v-text="`<${$t('Next')}`">&lt;后一个</a>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <router-link :to="`/HyperblockView/${up}`" v-if="up!=0" class="a" id="next" v-text="`${$t('Previous')}>`">前一个&gt;</router-link>
            <a v-else href="javascript:;" class="disable a" v-text="`${$t('Previous')}>`">前一个&gt;</a>
          </div>
          <!-- <div class="help fr" @click="helpBol = true">
            <img src="@/../public/static/img/blockView/help.png" alt="">
          </div> -->
        </div>
        
        <div class="clearfix">
          <div class="row clearfix" id="Localchains">
            <span class="key"  v-text="`${$t('HyperBlock')}：`">超块号：</span>
            <span class="cont" v-text="hyper_block">
              
            </span>
          </div>
          <div class="row clearfix" id="Localchains">
            <span class="key" v-text="`${$t('Localchains')}：`">子链数:</span>
            <span class="cont" v-text="localchains">
              
            </span>
          </div>
          <div class="row clearfix" id="Blocks">
            <span class="key" v-text="`${$t('Blocks')}：`">区块数:</span>
            <span class="cont" v-text="blocks">
              
            </span>
          </div>
          <div class="row clearfix" id="BlockSize">
            <span class="key" v-text="`${$t('BlockSize')}：`">块大小:</span>
            <span class="cont" v-text="block_size">
              
            </span>
          </div>
          
        </div>
        <div class="row clearfix" id="BlockVersion">
          <span class="key" v-text="`${$t('BlockVersion')}：`">块版本:</span>
          <span class="cont" v-text="block_version">
            
          </span>
        </div>
        <div>
          <div class="row clearfix" id="Time">
            <span class="key" v-text="`${$t('Time')}：`">时间戳:</span>
            <span class="cont" v-text="$retTime(time*1000)">
              
            </span>
          </div>
          <div class="row clearfix" id="BlockHash">
            <span class="key" v-text="`${$t('BlockHash')}：`">块哈希:</span>
            <span class="cont" v-text="block_hash">
              
            </span>
          </div>
          <div class="row clearfix" id="PreviousBlock">
            <span class="key" v-text="`${$t('PreviousBlockHash')}：`">前驱区块哈希:</span>
            <span class="cont" v-text="previous_local_block_hash">
              
            </span>
          </div>
        </div>
        <div class="dottedBottom"></div>
      </section>
      <div class="tit">
        <div class="fr" style="margin-top: 4px;font-size: 14px;">
          {{$t('Apps')}}: <span class="c_6900B7">{{apps_num}}</span>
        </div>
        <span v-text="$t('LocalChainList')"></span>
      </div>
      <section id="tab" class="section2">
        <div>
          <table class="table">
            <tr>
              <th v-text="$t('Localchain')"></th>
              <th v-text="$t('Blocks')"></th>
              <th v-text="$t('AppName')">App Name</th>
              <th v-text="$t('Difficulty')"></th>
              <th v-text="$t('Consensus')"></th>
            </tr>
            <tr 
            v-for="(item,index) in hyperblocks"
            :key="index"
            @click="$router.push(`/LocalchainView/${hyper_block}/${item.no}`)">
              <td>
                <a href="javascript:;" v-text="`${hyper_block},${item.no}`">

                </a>
                <!-- <router-link :to="`/LocalchainView/${hyper_block}/${item.no}`" v-text="`${hyper_block},${item.no}`">
                </router-link> -->
              </td>
              <td>{{item.blocks}}</td>
              <td>
                <img 
                  class="app_logo" 
                  :src="
                  item.app_logo ? item.app_logo : 
                  item.app_id == -1 ? './img/blockView/icon/hybrid.svg' :
                  item.app_type == 33 ? './img/blockView/icon/coin.svg' :
                  item.app_type == 17 ? './img/blockView/icon/token.svg' : 
                  './img/blockView/icon/default.svg'"/>
                <span class="app_name">{{item.app_name}}</span>
              </td>
              <td>{{item.difficulty}}</td>
              <td>{{item.Concensus}}</td>
            </tr>
          </table>
        </div>
        <!-- <router-link
        v-for="(item,index) in hyperblocks"
        class="chains clearfix"
        :to="`/LocalchainView/${hyper_block}/${item.no}`"
        :key="index">
          <div class="fl">
            <div class="fl block">
              <span class="cont" v-text="`${hyper_block},${item.no}`"></span>
              <span class="img"></span>
            </div>
            <div class="fl block_chain">
              <img v-if="item.block_chain == 'buddy chain'" src="@/../public/static/img/blockView/B.png" alt="icon">
              <img v-else src="@/../public/static/img/blockView/weizhi.png" alt="icon">
              <span class="key" v-text="item.block_chain"></span>
            </div>
          </div>
          <div class="fr bg2 hyperBlockView">
            <div class="fl blocks">
              <span class="cont"><span class="hexagon">B</span>{{item.blocks}}</span>
              <span class="key" v-text="$t('Blocks')">区块数</span>
            </div>
            <div class="fl difficulty">
              <span class="cont"><span class="hexagon">D</span>{{item.difficulty}}</span>
              <span class="key" v-text="$t('Difficulty')">难度</span>
            </div>
            <div class="fl concensus">
              <span class="cont"><span class="hexagon">C</span>{{item.Concensus}}</span>
              <span class="key" v-text="$t('Concensus')">共识算法</span>
            </div>
          </div>
        </router-link> -->
      </section>
      
      <pages 
        toLink="HyperblockView" 
        :pageCount="pageCount" 
        :hid="$route.params.hid"
        :page="page">
      </pages>
    </div>
    <!-- <help v-show="helpBol" @close="close" /> -->
  </div>
</template>
<script>
import help from '@/components/help.vue'
import pages from '@/components/pages.vue'
export default {
  data(){
    return{
      hyper_block: 0,
      block_hash: 0,
      previous_local_block_hash: 0,
      block_size: 0,
      block_version: 0,
      time: 0,
      localchains: 0,
      blocks: 0,
      down: 0,
      up: 0,
      hyperblocks: [],
      helpBol: false,
      moreBol: false,
      pageCount: 0,
      page: 0,
      apps_num: 0,
      loading: true,
    }
  },
  components:{
    help,pages
  },
  created(){
    this.init();
  },
  watch: {
    $route(){
      this.init();
    }
  },
  methods:{
    init(){
      this.$http({
        url:`hyperchain/hyperblock?hid=${this.$route.params.hid}&page=${this.$route.params.page}&pageSize=10`,
        baseURL: process.env.VUE_APP_CURRENTMODE,
        method: 'get',
      }).then((res)=>{
        var data = res.data;
        if(data.ret == 200){
          this.hyper_block = data.data.info.hyper_block;
          this.block_hash = data.data.info.block_hash;
          this.previous_local_block_hash = data.data.info.previous_local_block_hash;
          this.block_size = data.data.info.block_size;
          this.block_version = data.data.info.block_version;
          this.time = data.data.info.time;
          this.localchains = data.data.info.localchains;
          this.blocks = data.data.info.blocks;
          this.apps_num = data.data.apps_num;
          this.down = data.data.info.down;
          this.up = data.data.info.up;
          this.hyperblocks = data.data.data;
          this.pageCount = data.data.pages.pageCount;
          this.loading = false;
          if(data.data.pages.page<1){
            this.page = 1;
          }else{
            this.page = data.data.pages.page;
          }
        }
      })
    },
    close(){
      this.helpBol = false;
    }
  }
}
</script>
<style scoped lang="scss">
  .section2{
    &>div{
      width: 100%;
    }
   
  }
  @media screen and (max-width: 500px){
    .section2{
      .table{
        width: 510px!important;
      }
    }
  }
</style>



